import { createSlice } from "@reduxjs/toolkit";
import {
  AsyncState,
  addAsyncCasesToBuilderV2,
  addUserSessionScopeReducer,
  initialFetcherStateMeta,
} from "chat/imports/state";
import * as actions from "./asyncAction";

export type LiveBarState = AsyncState;

export const initialState: LiveBarState = {
  data: {
    isInitialized: false,
    streamList: [],
  },
  meta: { ...initialFetcherStateMeta, stale: false },
};

const slice = createSlice({
  name: "liveBar",
  initialState,
  reducers: {
    resetLiveBar: () => initialState,
  },
  extraReducers: (builder) => {
    addUserSessionScopeReducer(
      addAsyncCasesToBuilderV2({
        builder,
        action: actions.fetchLiveBarRequest,
        initialData: {
          ...initialState.data,
          isInitialized: true,
        },
        prepareData: (oldData, newData, meta) => {
          if (meta.arg.refresh) {
            return {
              ...newData,
              isInitialized: true,
              streamList: Array.isArray(newData.streamList)
                ? newData.streamList
                : [],
            };
          }

          return {
            ...oldData,
            ...newData,
            isInitialized: true,
            streamList: [
              ...(Array.isArray(oldData.streamList) ? oldData.streamList : []),
              ...(Array.isArray(newData.streamList) ? newData.streamList : []),
            ],
          };
        },
      }),
      () => initialState
    );
  },
});

export const { resetLiveBar } = slice.actions;

export const liveBarReducer = slice.reducer;
